__turbopack_context__.v({
  "className": "noto_sans_kannada_587e3644-module__3nq9jq__className",
});
